import React, {CSSProperties, useEffect, useState} from 'react';
import { useAppDispatch } from '../../store';
import {
    fetchPaymentInfo,
    fetchPaymentOptionsList,
    fetchWidgetInfoList,
    fetchPaymentHistoryList,
    updatePaymentMethod,
    updateRatePlan,
    updateWorkhubSubscriptionData,
    fetchRenewalChargingAmount, setRenewalChargingDataList,
    fetchDiscountInfo
} from '../../store/actions';
import { useSelector } from 'react-redux';
import { CardPanel } from './components/CardPanel';
import { CardPanelItem } from './components/CardPanelItem';
import {Form, message} from 'antd';
import { Modal } from '../../components';
import * as Constants from "../../constants";
import {PaymentMethodTitles, WidgetTypes} from '../../enum';
import {PropagateLoader, } from "react-spinners";

const override: CSSProperties = {
    display: "block",
    margin: "0 auto"
};

const BillingAndPlans = () => {
    const dispatch = useAppDispatch();
    const [isExpanded, setExpanded] = React.useState([]);
    const [isExpandedUsage, setExpandedUsage] = React.useState([]);
    const [isExpandedOneTime, setExpandedOneTime] = React.useState([]);
    const [isExpandedFree, setExpandedFree] = React.useState([]);
    const [displayMsisdnModal, setDisplayMsisdnModal] = useState<boolean>(false);
    const [msisdnList, setMsisdnList] = useState<any[]>([]);
    const [activeMsisdn, setActiveMsisdn] = useState<string>('');
    const [activeMsisdnObj, setActiveMsisdnObj] = useState<any>(null);
    const [activeCardObj, setActiveCardObj] = useState<any>(null);

    const [displayCardModal, setDisplayCardModal] = useState<boolean>(false);
    const [cardList, setCardList] = useState<any[]>([]);
    const [activeCard, setActiveCard] = useState<any>(null);

    const [paymentMethod, setPaymentMethod] = React.useState([]);
    const [paymentMethodChanged, setPaymentMethodChanged] = React.useState(false);
    const [paymentPackageChanged, setPaymentPackageChanged] = React.useState(false);

    const [showContent, setShowContent] = useState(false);

    const [payments, setPayments] = useState<any>([]);
    const [payHistoryLimit, setPayHistoryLimit] = useState(10);
    const [payHistoryOffset, setPayHistoryOffset] = useState(0);
    const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);
    const [payHistoryCount, setPayHistoryCount] = useState(0);
    const [limit, setLimit] = useState(10);
    const [subscriptionsOffset, setSubscriptionsOffset] = useState(0);
    const [perUsageOffset, setPerUsageOffset] = useState(0);
    const [oneTimeOffset, setOneTimeOffset] = useState(0);
    const [noChargeOffset, setNoChargeOffset] = useState(0);
    const [isInitDataLoadDone, setIsInitDataLoadDone] = useState(false);
    const [subsBasedWidgetList, setSubsBasedWidgetList] = useState<any>([]);
    const [perUsageWidgetList, setPerUsageWidgetList] = useState<any>([]);
    const [onetimeWidgetsList, setOnetimeWidgetList] = useState<any>([]);
    const [noChargeWidgetList, setNoChargeWidgetList] = useState<any>([]);
    const [paymentMethodChangedList, setPaymentMethodChangedList] = useState<any[]>([]);
    const [packageChangedList, setPackageChangedList] = useState<any[]>([]);
    const [paymentMethodError, setPaymentMethodError] = useState<any>({ "error": "", "widgetUuid": ""});
    const [subscriptionSearchVal, setSubscriptionSearchVal] = useState("");
    const [perUsageSearchVal, setPerUsageSearchVal] = useState("");
    const [noChargeSearchVal, setNoChargeSearchVal] = useState("");
    const [oneTimeSearchVal, setOneTimeSearchVal] = useState("");
    const [renewalChargingObjList, setRenewalChargingObjList] = useState<any[]>([]);

    const [form] = Form.useForm();
    const {
        userDetails,
        msisdnData,
        msisdnOtpData
    } = useSelector<any, any>(({ user }) => user);

    const {
        paymentInfo,
        subscriptionBasedWidgetList,
        perUsagedWidgetList,
        freeWidgetList,
        oneTimeWidgetList,
        paymentOptionsList,
        paymentHistoryList,
        paymentList,
        ratePlanUpdateResp,
        subWidgetsLoading,
        perUsageWidgetsLoading,
        oneTimeWidgetsLoading,
        noChargeWidgetsLoading,
        renewalChargingData,
        discountInfo
    } = useSelector<any, any>(({ settings }) => settings);

    const {
        workhubConfigData,
        workhubUpdateResp
    } = useSelector<any, any>(({ workhub }) => workhub);

    const useForceUpdate = () => {
        const [value, setValue] = useState(0);
        return () => setValue(value => value + 1);
    }

    const forceUpdate = useForceUpdate()

    useEffect(() => {
        const tenantGroupId = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        if (tenantGroupId !== "" && !isInitDataLoadDone) {
            dispatch<any>(fetchPaymentInfo(tenantGroupId));
            dispatch<any>(fetchDiscountInfo(tenantGroupId));
            dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.SUBSCRIPTION_BASED, limit, subscriptionsOffset, '0'));
            dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.PER_USAGE, limit, perUsageOffset, '0'));
            dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.NO_CHARGE, limit, noChargeOffset, '0'));
            dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.ONETIME, limit, oneTimeOffset, '0'));
            dispatch<any>(fetchPaymentOptionsList(tenantGroupId, 'null'));
            dispatch<any>(fetchPaymentHistoryList(tenantGroupId, payHistoryLimit, payHistoryOffset));
            setIsInitDataLoadDone(true);
        }
    }, [userDetails]);

    useEffect(() => {
        if (subscriptionBasedWidgetList && Array.isArray(subscriptionBasedWidgetList.Subscriptions) && subscriptionBasedWidgetList.Subscriptions.length > 0 && subsBasedWidgetList.length <= subscriptionsOffset) {
            let widgetArray = subsBasedWidgetList.concat(subscriptionBasedWidgetList.Subscriptions);
            let sortedWidgetArray = sortSubscriptions(widgetArray);
            setSubsBasedWidgetList(sortedWidgetArray);
        }
    }, [subscriptionBasedWidgetList]);

    useEffect(() => {
        if (oneTimeWidgetList && Array.isArray(oneTimeWidgetList.Subscriptions) && oneTimeWidgetList.Subscriptions.length > 0 && onetimeWidgetsList.length <= oneTimeOffset) {
            let widgetArray = onetimeWidgetsList.concat(oneTimeWidgetList.Subscriptions);
            let sortedWidgetArray = sortSubscriptions(widgetArray);
            setOnetimeWidgetList(sortedWidgetArray);
        }
    }, [oneTimeWidgetList]);

    useEffect(() => {
        if (freeWidgetList && Array.isArray(freeWidgetList.Subscriptions) && freeWidgetList.Subscriptions.length > 0 && noChargeWidgetList.length <= noChargeOffset) {
            let widgetArray = noChargeWidgetList.concat(freeWidgetList.Subscriptions);
            let sortedWidgetArray = sortSubscriptions(widgetArray);
            setNoChargeWidgetList(sortedWidgetArray);
        }
    }, [freeWidgetList]);

    useEffect(() => {
        if (perUsagedWidgetList && Array.isArray(perUsagedWidgetList.Subscriptions) && perUsagedWidgetList.Subscriptions.length > 0 && perUsageWidgetList.length <= perUsageOffset) {
            let widgetArray = perUsageWidgetList.concat(perUsagedWidgetList.Subscriptions);
            let sortedWidgetArray = sortSubscriptions(widgetArray);
            setPerUsageWidgetList(sortedWidgetArray);
        }
    }, [perUsagedWidgetList]);

    useEffect(() => {
        if (workhubConfigData && workhubConfigData.isChanged) {
            setPaymentPackageChanged(true);
        }
    }, [workhubConfigData]);

    useEffect(() => {
        if (ratePlanUpdateResp) {
            if (ratePlanUpdateResp.status === 'Success') {
                message.success("You have successfully changed your package").then(() => {
                    window.location.reload();
                });
            }
        }
    }, [ratePlanUpdateResp]);

    useEffect(() => {
        if (workhubUpdateResp) {
            if (workhubUpdateResp.success) {
                message.success("You have successfully changed your package").then(() => {
                    window.location.reload();
                });
            }
        }
    }, [workhubUpdateResp]);

    useEffect(() => {
        if (renewalChargingData) {
            let chargingObjList = renewalChargingObjList;
            let existingDataIndex = chargingObjList.findIndex((obj: any) => (obj.widgetType === renewalChargingData.widgetType && obj.index.toString() === renewalChargingData.index.toString()))
            if(existingDataIndex == -1) {
                chargingObjList = [...chargingObjList, renewalChargingData];
                setRenewalChargingObjList(chargingObjList)
                dispatch<any>(setRenewalChargingDataList(chargingObjList));
            } else {
                if(chargingObjList[existingDataIndex].chargingAmount !== renewalChargingData.chargingAmount) {
                    chargingObjList[existingDataIndex] = renewalChargingData;
                    setRenewalChargingObjList(chargingObjList)
                    dispatch<any>(setRenewalChargingDataList(chargingObjList));
                }
            }
        }
    }, [renewalChargingData]);

    const sortSubscriptions = (widgetArray: any) => {
        widgetArray.sort((a: any, b: any) => {
            if (checkUserRetryEnable(a) && !checkUserRetryEnable(b)) {
                return -1;
            } else if (!checkUserRetryEnable(a) && checkUserRetryEnable(b)) {
                return 1;
            } else {
                return 0;
            }
        });
        return widgetArray;
    }

    const checkUserRetryEnable = (widget: any) => {
        if (widget.isUserRetryEnable && !widget.WidgetSubscriptions.isSubscriptionActive) {
            return true
        } else {
            return false
        }
    }

    const getRenewalChargingAmount = (widgetType: string, index: number) => {
        let ratePlanId = '';
        switch (widgetType) {
            case WidgetTypes.SUBSCRIPTION_BASED:
                ratePlanId = findActiveRatePlanId(subsBasedWidgetList[index]);
                break;
            case WidgetTypes.PER_USAGE:
                ratePlanId = findActiveRatePlanId(perUsagedWidgetList[index]);
                break;
            default:
            // code block
        }
        if(ratePlanId) {
            dispatch<any>(fetchRenewalChargingAmount(widgetType, index, ratePlanId));
        }
    }

    const findActiveRatePlanId = (widgetObj: any) => {
        let ratePlanId = "";
        let rateCardDetail = widgetObj.WidgetRate.filter((obj: any) => obj.RatePlaneDetails.length > 0);
        if (rateCardDetail && rateCardDetail.length > 0) {
            if(rateCardDetail[0].RatePlaneDetails[0].RatePlans.status == "Failed") {
                ratePlanId = rateCardDetail[0].RatePlaneDetails[0].RatePlans.id;
            }
        }
        return ratePlanId
    }

    const onChangeExpanded = (method: any, index: number) => {
        if (method) {
            getRenewalChargingAmount(WidgetTypes.SUBSCRIPTION_BASED, index);
        }
        let isExpandedArr: any = isExpanded;
        isExpandedArr[index] = method;
        setExpanded(isExpandedArr);
        forceUpdate();
    }

    const onChangeExpandedUsage = (method: any, index: number) => {
        let isExpandedArr: any = isExpandedUsage;
        isExpandedArr[index] = method;
        setExpandedUsage(isExpandedArr);
        forceUpdate();
    }

    const onChangeExpandedOneTime = (method: any, index: number) => {
        let isExpandedArr: any = isExpandedOneTime;
        isExpandedArr[index] = method;
        setExpandedOneTime(isExpandedArr);
        forceUpdate();
    }

    const onChangeExpandedFree = (method: any, index: number) => {
        let isExpandedArr: any = isExpandedFree;
        isExpandedArr[index] = method;
        setExpandedFree(isExpandedArr);
        forceUpdate();
    }

    const onChangeMethod = (e: any) => {

    }

    const onFieldsChange = (changedFields: any, widgetUuid: any, msisdn: string, invoiceNo: string) => {
        if (changedFields[0].name[0] === "paymentMethod") {
            setPaymentMethodChanged(true);
            let methodChangedArr = paymentMethodChangedList;
            methodChangedArr.push({
                widgetUuid: widgetUuid,
                paymentMethod: changedFields[0].value === 1 ? PaymentMethodTitles.ADD_TO_BILL : PaymentMethodTitles.CARD_PAYMENT,
                msisdn: msisdn,
                invoiceNo: invoiceNo
            })
            setPaymentMethodChangedList(methodChangedArr);
            setPaymentMethodError({
                error: "",
                widgetUuid: ""
            })
        }
        if (changedFields[0].name[0] === "paymentPackage") {
            setPaymentPackageChanged(true);
            let packageChangedArr = packageChangedList;
            packageChangedArr.push(widgetUuid)
            setPackageChangedList(packageChangedArr);
        }
    }

    const getCurrentMsisdn = async (widgetUuid: string) => {
        let currentMsisdn;
        if (activeMsisdnObj && activeMsisdnObj.widgetUuid === widgetUuid && activeMsisdnObj.msisdn) {
            currentMsisdn = activeMsisdnObj.msisdn;
        } else {
            let changedObj = paymentMethodChangedList.find((obj: any) => obj.widgetUuid === widgetUuid);
            currentMsisdn = changedObj ? changedObj.msisdn : null;
        }
        return currentMsisdn;
    }

    const getCurrentCard = async (widgetUuid: string) => {
        let currentCard;
        if (activeCardObj && activeCardObj.widgetUuid === widgetUuid && activeCardObj.invoiceNo) {
            currentCard = activeCardObj.invoiceNo;
        } else {
            let changedObj = paymentMethodChangedList.find((obj: any) => obj.widgetUuid === widgetUuid);
            currentCard = changedObj ? changedObj.invoiceNo : null;
        }
        return currentCard;
    }

    const isJsonString = (str: string) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    const onFinishSelect = async (values: any) => {
        const tenantGroupId = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";

        if (paymentMethodChanged) {
            let msisdn = await getCurrentMsisdn(values.widgetUuid);
            let card = await getCurrentCard(values.widgetUuid);
            let req = null;
            if (values.paymentMethod === 1) {
                if(msisdn) {
                    req = {
                        "paymentMethod": PaymentMethodTitles.ADD_TO_BILL,
                        "msisdn": msisdn,
                        "invoiceNo": null
                    }
                } else {
                    setPaymentMethodError({
                        error: "Please select a charging number to proceed with Add to Bill payment method.",
                        widgetUuid: values.widgetUuid
                    })
                }
            } else {
                if(card) {
                    req = {
                        "paymentMethod": PaymentMethodTitles.CARD_PAYMENT,
                        "msisdn": null,
                        "invoiceNo": card
                    }
                } else {
                    setPaymentMethodError({
                        error: "Please select a card to proceed with card payment method.",
                        widgetUuid: values.widgetUuid
                    })
                }
            }
            // let req = {
            //     "paymentMethod": values.paymentMethod === 1 ? "AddToBill" : "Card payment",
            //     "msisdn": msisdn ? msisdn : null,
            //     "invoiceNo": card ? card : null
            // }
            dispatch<any>(updatePaymentMethod(tenantGroupId, values.widgetUuid, req));
        }
        if (paymentPackageChanged) {
            if (Constants.WORKHUB_WIDGET_IDS.includes(values.widgetUuid) && workhubConfigData) {
                let usageCount = isJsonString(values.paymentPackage) ? JSON.parse(values.paymentPackage).uuid : values.paymentPackage;
                let workhubUpdateReq = {
                    "usageCount": usageCount,
                    "widgetCount": workhubConfigData.widgetCount,
                    "subscriptionRate": workhubConfigData.subscriptionRate,
                    "ratePlans": [usageCount],
                    "workhubConfigId": workhubConfigData.workhubConfigId,
                    "masterWidgetUuid": workhubConfigData.masterWidgetUuid
                }
                dispatch<any>(updateWorkhubSubscriptionData(tenantGroupId, values.widgetUuid, workhubUpdateReq));
            } else {
                let packageReq = {
                    "newRatePlans": [values.paymentPackage]
                }
                dispatch<any>(updateRatePlan(tenantGroupId, values.widgetUuid, packageReq));
            }
        }
        setPaymentMethodChanged(false);
        setPaymentPackageChanged(false);
    }

    useEffect(() => {
        if (paymentHistoryList) {
            setPayHistoryCount(paymentHistoryList.count);
            // Map through each response object in the array and transform payment history
            const transformedDataArray = paymentHistoryList && paymentHistoryList.paymentList && Array.isArray(paymentHistoryList.paymentList) && paymentHistoryList.paymentList.flatMap((responseObj: any) => {
                return responseObj
            })
            if (paymentHistoryLoading) {
                let paymentList = payments;
                transformedDataArray.map((item: any) => {
                    paymentList.push(item)
                })
                setPayments(paymentList);
                setPaymentHistoryLoading(false);
            } else {
                setPayments(transformedDataArray);
            }
        }
    }, [paymentHistoryList])

    const onLoadMore = () => {
        setPaymentHistoryLoading(true);
        const tenantGroupId = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        if (tenantGroupId !== "") {
            dispatch<any>(fetchPaymentHistoryList(tenantGroupId, payHistoryLimit, payHistoryOffset + 10));
            setPayHistoryOffset(payHistoryOffset + 10)
        }
    }

    const onLoadMoreWidgets = async (type: string) => {
        const tenantGroupId = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        let newOffset = 0;
        if (tenantGroupId !== "") {
            switch (type) {
                case WidgetTypes.SUBSCRIPTION_BASED : {
                    newOffset = subscriptionsOffset + 10;
                    setSubscriptionsOffset(newOffset);
                    dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.SUBSCRIPTION_BASED, limit, newOffset, '0'));
                    break;
                }
                case WidgetTypes.PER_USAGE : {
                    newOffset = perUsageOffset + 10;
                    setPerUsageOffset(newOffset);
                    dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.PER_USAGE, limit, newOffset, '0'));
                    break;
                }
                case WidgetTypes.ONETIME : {
                    newOffset = oneTimeOffset + 10;
                    setOneTimeOffset(newOffset);
                    dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.ONETIME, limit, newOffset, '0'));
                    break;
                }
                case WidgetTypes.NO_CHARGE : {
                    newOffset = noChargeOffset + 10;
                    setNoChargeOffset(newOffset);
                    dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.NO_CHARGE, limit, newOffset, '0'));
                    break;
                }
            }
        }
    }

    const onChangeNumber = (e:  React.ChangeEvent<HTMLInputElement>) => {
        setActiveMsisdn(e.target.value);
        setPaymentMethodChanged(true);
        setActiveMsisdnObj({
            ...activeMsisdnObj,
            msisdn: e.target.value
        })
    }

    const onChangeCard = (e:  React.ChangeEvent<HTMLInputElement>) => {
        setActiveCard(JSON.parse(e.target.value))
        setPaymentMethodChanged(true);
        setActiveCardObj({
            ...activeCardObj,
            invoiceNo: JSON.parse(e.target.value).invoiceNo
        })
    }

    const checkIsDisabled = (widgetUUID: string, editable: boolean) => {
        let isDisabled = true;
        let paymentMethodChangedObj = paymentMethodChangedList.find((obj: any) => obj.widgetUuid === widgetUUID);
        if (paymentMethodChanged && paymentMethodChangedObj) {
            if (paymentMethodChangedObj.paymentMethod === PaymentMethodTitles.ADD_TO_BILL && paymentMethodChangedObj.msisdn) {
                isDisabled = false
            } else if (paymentMethodChangedObj.paymentMethod === PaymentMethodTitles.CARD_PAYMENT && paymentMethodChangedObj.invoiceNo){
                isDisabled = false
            }
        }
        if (paymentPackageChanged && packageChangedList.includes(widgetUUID)) {
            if(editable) {
                isDisabled = false
            }
        }
        if (activeMsisdnObj && activeMsisdnObj.widgetUuid === widgetUUID && activeMsisdnObj.msisdn) {
            isDisabled = false
        }
        if (activeCardObj && activeCardObj.widgetUuid === widgetUUID && activeCardObj.invoiceNo) {
            isDisabled = false
        }
        if (workhubConfigData && workhubConfigData.isChanged) {
            isDisabled = false
        }
        return isDisabled;
    }

    const onChangeSearchVal = (value: string, widgetType: string) => {
        switch(widgetType) {
            case WidgetTypes.SUBSCRIPTION_BASED:
                setSubscriptionSearchVal(value);
                break;
            case WidgetTypes.PER_USAGE:
                setPerUsageSearchVal(value);
                break;
            case WidgetTypes.ONETIME:
                setOneTimeSearchVal(value);
                break;
            case WidgetTypes.NO_CHARGE:
                setNoChargeSearchVal(value);
                break;
        }
    }

    const onSearchWidgets = (widgetType: string) => {
        const tenantGroupId = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        switch(widgetType) {
            case WidgetTypes.SUBSCRIPTION_BASED:
                setSubsBasedWidgetList([]);
                setSubscriptionsOffset(0);
                dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.SUBSCRIPTION_BASED, limit, subscriptionsOffset, subscriptionSearchVal ? subscriptionSearchVal : '0'));
                break;
            case WidgetTypes.PER_USAGE:
                setPerUsageWidgetList([]);
                setPerUsageOffset(0);
                dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.PER_USAGE, limit, perUsageOffset, perUsageSearchVal ? perUsageSearchVal : '0'));
                break;
            case WidgetTypes.ONETIME:
                setOnetimeWidgetList([]);
                setOneTimeOffset(0);
                dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.ONETIME, limit, oneTimeOffset, oneTimeSearchVal ? oneTimeSearchVal : '0'));
                break;
            case WidgetTypes.NO_CHARGE:
                setNoChargeWidgetList([]);
                setNoChargeOffset(0);
                dispatch<any>(fetchWidgetInfoList(tenantGroupId, WidgetTypes.NO_CHARGE, limit, noChargeOffset, noChargeSearchVal ? noChargeSearchVal : '0'));
                break;
        }
    }

    return (
        <React.Fragment>
            <div className="sub-nav-inner-container__wrapper billing-and-plans-payement">
                <div className="sub-nav-inner-container content-holder">
                    <div className="content-holder-header__wrapper">
                        <div className="content-holder-header">
                            <h4 className="inner-title">Billing &amp; Plans</h4>
                        </div>
                    </div>
                    <div className={"billing-and-plans-loader"}>
                        {/*<p style={{marginTop: '30px', marginBottom: '30px'}}>{"provisionStatus"}</p>*/}
                        <PropagateLoader
                            cssOverride={override}
                            size={15}
                            color={"#4E286D"}
                            loading={subWidgetsLoading || perUsageWidgetsLoading || oneTimeWidgetsLoading || noChargeWidgetsLoading}
                        />
                    </div>
                    {(discountInfo && discountInfo.entbalance) ? <div className="alert green">
                      <span className="alert-text__wrapper">
                          <i className="alert-icon bi bi-info-circle-fill"/>
                          <span className="alert-text">You are eligible for a discount of Rs.{discountInfo.entbalance.toFixed(2)} for your enterprise.</span>
                      </span>
                    </div> : <></>}
                    {/* Below Removed Temporarily */}
                    {showContent &&
                        <div className="sub-nav-inner-container stats-widgets__wrapper">
                            <div className="stats-widget-item__wrapper">
                                <div className="stats-widget-item card">
                                    <span className="stats-title">Current monthly bill</span>
                                    <span className="stats-data">
                                        <span className="stats-unit">Rs.</span>{(paymentInfo && Array.isArray(paymentInfo.currentMonthlyBillAmount) && paymentInfo.currentMonthlyBillAmount[0].currentMonthlyBillAmount) ? paymentInfo.currentMonthlyBillAmount[0].currentMonthlyBillAmount : '0.00'}
                                    </span>
                                    <span className="stats-peak">
                                        {/* <span className="icon__wrapper">
                                        {" "}
                                        <i className="bi bi-arrow-up txt-red" />
                                    </span> */}
                                        {/* +12% higher than last month */}
                                    </span>
                                </div>
                                {(paymentInfo && Array.isArray(paymentInfo.totalDiscountAmount) && paymentInfo.totalDiscountAmount[0].totalDiscountAmount && paymentInfo.totalDiscountAmount[0].totalDiscountAmount > 0) && <div className="float-badge round brighter-green right-align">
                                    <span className="icon__wrapper">
                                        <svg
                                            width="14px"
                                            height="14.0000556px"
                                            viewBox="0 0 14 14.0000556"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                        >
                                            <g
                                                id="UI---Settings"
                                                stroke="none"
                                                strokeWidth={1}
                                                fill="none"
                                                fillRule="evenodd"
                                            >
                                                <g
                                                    id="App-portal/settings/Billing"
                                                    transform="translate(-728.469550, -266.000000)"
                                                    fill="#FFFFFF"
                                                    fillRule="nonzero"
                                                >
                                                    <g
                                                        id="noun-percent-2463588"
                                                        transform="translate(728.469550, 266.000000)"
                                                    >
                                                        <path
                                                            d="M6.999,0 L7.30847545,0.00713506394 C9.05204244,0.0858741405 10.7079808,0.813157548 11.9474641,2.05253592 C13.2597748,3.36504113 13.9979384,5.1441593 14,7.00005556 C14,8.85645181 13.2624693,10.63707 11.9497419,11.9497974 C10.6369589,13.2625249 8.85639626,14.0000556 7,14.0000556 C5.14360374,14.0000556 3.36298557,13.2625249 2.05025814,11.9497974 C0.737530704,10.6370144 0,8.85645181 0,7.00005556 C0,5.1436593 0.737530704,3.36304112 2.05025814,2.05031369 C3.29010873,0.810515562 4.94705855,0.083729156 6.69134522,0.00680164831 L6.999,0 Z M9.02245247,7.44730733 C8.60470081,7.44730733 8.203977,7.61330799 7.90861472,7.90867027 C7.61316077,8.20403256 7.44725177,8.60475637 7.44725177,9.02250803 C7.44725177,9.44025968 7.61314132,9.84087238 7.90861472,10.1363458 C8.203977,10.4316886 8.60470081,10.5975976 9.02245247,10.5975976 C9.4399819,10.5971532 9.84037238,10.4310414 10.1357347,10.1357902 C10.4309831,9.84042794 10.597108,9.44014857 10.5975421,9.02250803 C10.5975421,8.60475637 10.4316525,8.20403256 10.1361791,7.90867027 C9.84081683,7.61332466 9.44020413,7.44730733 9.02245247,7.44730733 Z M10.0663455,3.49378903 L3.49326386,10.0665929 C3.3717356,10.1881212 3.3717356,10.3850664 3.49326386,10.5065946 C3.61468101,10.6280144 3.81173457,10.6280144 3.9331545,10.5064861 L10.5062361,3.93368228 C10.6277644,3.81215402 10.6277644,3.61520879 10.5062361,3.49368053 C10.384819,3.37226077 10.1877654,3.37226077 10.0663455,3.49378903 Z M9.02264692,8.06967091 C9.548899,8.06967091 9.97556736,8.49631149 9.97556736,9.02259136 C9.97556736,9.54884345 9.54892678,9.97551181 9.02264692,9.97551181 C8.49628372,9.97551181 8.06961536,9.54887123 8.06961536,9.02259136 C8.06961536,8.49633927 8.49625594,8.06967091 9.02264692,8.06967091 Z M4.97743642,3.40256906 C4.55990698,3.4030135 4.15951651,3.56912527 3.86415422,3.86437645 C3.56890583,4.15973873 3.40278086,4.5600181 3.40234683,4.97765864 C3.40234683,5.3954103 3.56823638,5.79613411 3.86370978,6.09149639 C4.15907206,6.38684201 4.55968476,6.55285934 4.97743642,6.55285934 C5.39518808,6.55285934 5.79591189,6.38685868 6.09127417,6.09149639 C6.38672812,5.79613411 6.55263711,5.3954103 6.55263711,4.97765864 C6.55263711,4.55990698 6.38674757,4.15929428 6.09127417,3.86382089 C5.79591189,3.56847805 5.39518808,3.40256906 4.97743642,3.40256906 Z M4.97751975,4.02465486 C5.50388295,4.02465486 5.93055131,4.45129544 5.93055131,4.97757531 C5.93055131,5.5038274 5.50391073,5.93049576 4.97751975,5.93049576 C4.45126766,5.93049576 4.0245993,5.50385517 4.0245993,4.97757531 C4.0245993,4.45132322 4.45123989,4.02465486 4.97751975,4.02465486 Z"
                                                            id="Combined-Shape"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="text__wrapper">Discount Applied</span>
                                </div>}
                            </div>
                            <div className="stats-widget-item__wrapper">
                                <div className="stats-widget-item card">
                                    <span className="stats-title">Total discounted value</span>
                                    <span className="stats-data txt-green">
                                        <span className="stats-unit "> -Rs.</span>{(paymentInfo && Array.isArray(paymentInfo.totalDiscountAmount) && paymentInfo.totalDiscountAmount[0].totalDiscountAmount) ? paymentInfo.totalDiscountAmount[0].totalDiscountAmount : '0.00'}
                                    </span>
                                    <span className="stats-peak">
                                        <span className="icon__wrapper"> </span>This amount has been already
                                        deducted from your currect monthly bill
                                    </span>
                                </div>
                            </div>
                            <div className="stats-widget-item__wrapper">
                                <div className="stats-widget-item card">
                                    <span className="stats-title">
                                        Payment informations&nbsp;
                                        <i className="bi bi-arrow-right" />
                                    </span>
                                    <a href="">Update payment method</a>
                                    <a href="">Manage spending limit</a>
                                    <a href="">View payment history</a>
                                </div>
                            </div>
                        </div>
                    }

                    {subscriptionBasedWidgetList && subsBasedWidgetList && <CardPanel
                        headerTitle={'Subscriptions'}
                        headerSubTitle={'Here the list of apps that are billed to you on a recurring basis.'}
                        panelHeaderTitle={`${subsBasedWidgetList.length} Total subscriptions`}
                        searchAvailable={true}
                        widgetType={WidgetTypes.SUBSCRIPTION_BASED}
                        onChangeValue={onChangeSearchVal}
                        onSearchValue={onSearchWidgets}
                        searchValue={subscriptionSearchVal}
                    >
                        {subsBasedWidgetList.map((value: any, index: number) => {
                            return (
                                <CardPanelItem
                                    keyIndex={index}
                                    expandable={true}
                                    isExpanded={isExpanded[index]}
                                    setExpanded={onChangeExpanded}
                                    widget={value}
                                    onChangeMethod={onChangeMethod}
                                    msisdns={subscriptionBasedWidgetList.MsisdnConfigs}
                                    cards={subscriptionBasedWidgetList.TenantGenieCardDetails}
                                    setMsisdnList={setMsisdnList}
                                    setDisplayMsisdnModal={setDisplayMsisdnModal}
                                    setActiveMsisdn={setActiveMsisdn}
                                    activeMsisdn={activeMsisdn}
                                    setActiveCard={setActiveCard}
                                    activeCard={activeCard}
                                    setDisplayCardModal={setDisplayCardModal}
                                    setCardList={setCardList}
                                    onFinishSelect={onFinishSelect}
                                    form={form}
                                    onFieldsChange={onFieldsChange}
                                    activeMsisdnObj={activeMsisdnObj}
                                    setActiveMsisdnObj={setActiveMsisdnObj}
                                    activeCardObj={activeCardObj}
                                    setActiveCardObj={setActiveCardObj}
                                    checkIsDisabled={checkIsDisabled}
                                    paymentMethodError={paymentMethodError}
                                />
                            )
                        })}

                        {/*<div className="panel-table-list-item">*/}
                        {/*    <div className="panel-table-listing-item__inner">*/}
                        {/*        <a onClick={()=>onLoadMoreWidgets(WidgetTypes.SUBSCRIPTION_BASED)}>View more</a>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </CardPanel>}

                    {perUsagedWidgetList && perUsageWidgetList && <CardPanel
                        headerTitle={'Per Usage / Pay as you go'}
                        headerSubTitle={'List of apps that bill you according to your usage or pay-as-you-go terms'}
                        panelHeaderTitle={`${perUsageWidgetList.length} Total subscriptions`}
                        searchAvailable={true}
                        widgetType={WidgetTypes.PER_USAGE}
                        onChangeValue={onChangeSearchVal}
                        onSearchValue={onSearchWidgets}
                        searchValue={perUsageSearchVal}
                    >
                        {perUsageWidgetList.map((value: any, index: number) => {
                            return (
                                <CardPanelItem
                                    keyIndex={index}
                                    expandable={true}
                                    isExpanded={isExpandedUsage[index]}
                                    setExpanded={onChangeExpandedUsage}
                                    widget={value}
                                    onChangeMethod={onChangeMethod}
                                    msisdns={perUsagedWidgetList.MsisdnConfigs}
                                    cards={perUsagedWidgetList.TenantGenieCardDetails}
                                    setMsisdnList={setMsisdnList}
                                    setDisplayMsisdnModal={setDisplayMsisdnModal}
                                    setActiveMsisdn={setActiveMsisdn}
                                    activeMsisdn={activeMsisdn}
                                    setActiveCard={setActiveCard}
                                    activeCard={activeCard}
                                    setDisplayCardModal={setDisplayCardModal}
                                    setCardList={setCardList}
                                    onFinishSelect={onFinishSelect}
                                    form={form}
                                    onFieldsChange={onFieldsChange}
                                    activeMsisdnObj={activeMsisdnObj}
                                    setActiveMsisdnObj={setActiveMsisdnObj}
                                    activeCardObj={activeCardObj}
                                    setActiveCardObj={setActiveCardObj}
                                    checkIsDisabled={checkIsDisabled}
                                    paymentMethodError={paymentMethodError}
                                />
                            )
                        })}
                        {/*<div className="panel-table-list-item">*/}
                        {/*    <div className="panel-table-listing-item__inner">*/}
                        {/*        <a onClick={()=>onLoadMoreWidgets(WidgetTypes.PER_USAGE)}>View more</a>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </CardPanel>}

                    {oneTimeWidgetList && onetimeWidgetsList && <CardPanel
                        headerTitle={'One time charging'}
                        headerSubTitle={'List of apps that charge a one-time fee for the entire product lifespan.'}
                        panelHeaderTitle={`${onetimeWidgetsList.length} Total subscriptions`}
                        searchAvailable={true}
                        widgetType={WidgetTypes.ONETIME}
                        onChangeValue={onChangeSearchVal}
                        onSearchValue={onSearchWidgets}
                        searchValue={oneTimeSearchVal}
                    >
                        {onetimeWidgetsList.map((value: any, index: number) => {
                            return (
                                <CardPanelItem
                                    keyIndex={index}
                                    expandable={true}
                                    isExpanded={isExpandedOneTime[index]}
                                    setExpanded={onChangeExpandedOneTime}
                                    widget={value}
                                    onChangeMethod={onChangeMethod}
                                    msisdns={oneTimeWidgetList.MsisdnConfigs}
                                    cards={oneTimeWidgetList.TenantGenieCardDetails}
                                    setMsisdnList={setMsisdnList}
                                    setDisplayMsisdnModal={setDisplayMsisdnModal}
                                    setActiveMsisdn={setActiveMsisdn}
                                    activeMsisdn={activeMsisdn}
                                    setActiveCard={setActiveCard}
                                    activeCard={activeCard}
                                    setDisplayCardModal={setDisplayCardModal}
                                    setCardList={setCardList}
                                    onFinishSelect={onFinishSelect}
                                    form={form}
                                    onFieldsChange={onFieldsChange}
                                    activeMsisdnObj={activeMsisdnObj}
                                    setActiveMsisdnObj={setActiveMsisdnObj}
                                    activeCardObj={activeCardObj}
                                    setActiveCardObj={setActiveCardObj}
                                    checkIsDisabled={checkIsDisabled}
                                    paymentMethodError={paymentMethodError}
                                />
                            )
                        })}

                        {/*<div className="panel-table-list-item">*/}
                        {/*    <div className="panel-table-listing-item__inner">*/}
                        {/*        <a onClick={()=>onLoadMoreWidgets(WidgetTypes.ONETIME)}>View more</a>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </CardPanel>}

                    {freeWidgetList && noChargeWidgetList && <CardPanel
                        headerTitle={'No Charging'}
                        headerSubTitle={'Charging will be depended on the external app. Reach out to Marketplace support team.'}
                        panelHeaderTitle={`${noChargeWidgetList.length} Total subscriptions`}
                        searchAvailable={true}
                        widgetType={WidgetTypes.NO_CHARGE}
                        onChangeValue={onChangeSearchVal}
                        onSearchValue={onSearchWidgets}
                        searchValue={noChargeSearchVal}
                    >
                        {noChargeWidgetList.map((value: any, index: number) => {
                            return (
                                <CardPanelItem
                                    keyIndex={index}
                                    expandable={true}
                                    isExpanded={isExpandedFree[index]}
                                    setExpanded={onChangeExpandedFree}
                                    widget={value}
                                    onChangeMethod={onChangeMethod}
                                    msisdns={freeWidgetList.MsisdnConfigs}
                                    cards={freeWidgetList.TenantGenieCardDetails}
                                    setMsisdnList={setMsisdnList}
                                    setDisplayMsisdnModal={setDisplayMsisdnModal}
                                    setActiveMsisdn={setActiveMsisdn}
                                    activeMsisdn={activeMsisdn}
                                    setActiveCard={setActiveCard}
                                    activeCard={activeCard}
                                    setDisplayCardModal={setDisplayCardModal}
                                    setCardList={setCardList}
                                    onFinishSelect={onFinishSelect}
                                    form={form}
                                    onFieldsChange={onFieldsChange}
                                    activeMsisdnObj={activeMsisdnObj}
                                    setActiveMsisdnObj={setActiveMsisdnObj}
                                    activeCardObj={activeCardObj}
                                    setActiveCardObj={setActiveCardObj}
                                    checkIsDisabled={checkIsDisabled}
                                    paymentMethodError={paymentMethodError}
                                />
                            )
                        })}

                        {/*<div className="panel-table-list-item">*/}
                        {/*    <div className="panel-table-listing-item__inner">*/}
                        {/*        <a onClick={()=>onLoadMoreWidgets(WidgetTypes.NO_CHARGE)}>View more</a>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </CardPanel>}

                    <CardPanel
                        headerTitle={'Payment history'}
                        headerSubTitle={'List of payment transactions made via your subscribed applications'}
                        panelHeaderTitle={(payHistoryCount && payHistoryCount > 0) ? `${payHistoryCount} Total`: `Currently, there is no payment history available within your enterprise's records.`}
                        searchAvailable={false}
                    >
                        {payments && Array.isArray(payments) && payments.map((value: any, index: number) => {
                            return (
                                <>
                                    <div className="panel-table-list-item">
                                        <div className="panel-table-listing-item__inner">
                                            <div className="feature-details__wrapper">
                                                <div
                                                    className="card app-media-holder"
                                                    style={{
                                                        backgroundImage: `url(${value.widgetTitle.icon})`
                                                    }}
                                                ></div>
                                                <div className="feature-details-title__wrapper no-shade">
                                                    <span className="title">{value.widgetTitle.title}</span>
                                                    <div className="payment-history-data">
                                                        <span className="small-desc">{value.paymentHistory.updatedAt}</span>
                                                        {(value.paymentHistory.dataValues && value.paymentHistory.dataValues.paymentMethodId == Constants.ADD_TO_BILL) ?
                                                            <label className="payment-method-badge badge-green">Add to Bill</label>
                                                            : (value.paymentHistory.dataValues && value.paymentHistory.dataValues.paymentMethodId == Constants.CREDIT_CARD) ?
                                                                <label className="payment-method-badge badge-orange">Credit Card</label>
                                                                : (value.paymentHistory.dataValues && value.paymentHistory.dataValues.paymentMethodId == Constants.INVOICE) ?
                                                                    <label className="payment-method-badge badge-gray">Invoice</label>
                                                                    : <></>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel-table-listing-item__inner">
                                            <div className="panel-table-right-align-item__wrapper">
                                                <div className="panel-table-right-align-item">
                                                    <span className="title txt-red">
                                                        -
                                                        {value.totalAmount}
                                                        LKR Paid
                                                    </span>
                                                    {value.cardDetails == '' || value.cardDetails == null ?
                                                        <span className="small-desc">{value.paymentHistory.msisdn}</span>
                                                        :
                                                        <span className="small-desc">{value.cardDetails.cardType} {value.cardDetails.maskCardNo}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        })}

                        {(payHistoryCount-(payHistoryOffset+10) > 0) &&<div className="panel-table-list-item">
                            <div className="panel-table-listing-item__inner">
                                <a onClick={onLoadMore}>View more</a>
                            </div>
                        </div>}

                    </CardPanel>
                    {/* <CardPanel
                        headerTitle={'Payment methods'}
                        headerSubTitle={'Brief list of payment methods use in'}
                        panelHeaderTitle={`${(paymentOptionsList && Array.isArray(paymentOptionsList) &&
                            paymentOptionsList.length > 0) ? paymentOptionsList.length : '0'} Total`}>
                        {paymentOptionsList && Array.isArray(paymentOptionsList) && paymentOptionsList.map((value: any, index: number) => {
                            return (
                                <div className="panel-table-list-item">
                                    <div className="panel-table-listing-item__inner">
                                        <div className="feature-details__wrapper">
                                            <div
                                                className="card app-media-holder"
                                                style={{
                                                    backgroundImage:
                                                        "url(/src/assets/images/icons/payment-icon-mastercard.svg)"
                                                }}
                                            ></div>
                                            <div className="feature-details-title__wrapper no-shade">
                                                <span className="title">{value.cardType} {value.maskCardNo}</span>
                                                <span className="title">{value.msisdn}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="panel-table-listing-item__inner">
                                        <div className="panel-table-right-align-item__wrapper">
                                            <div className="panel-table-right-align-item">
                                                <p className="">
                                                    <i className="bi bi-2-circle-fill" />
                                                    &nbsp;{value.isPrimary ? "Primary" : "Secondary"}
                                                </p>
                                            </div>
                                            <div className="panel-table-right-align-item">
                                                <span className="step-status-badge">
                                                    <span className="status-icon__wrapper txt-green">
                                                        <i className="bi bi-check-circle-fill" />
                                                    </span>
                                                    {value.cardStatus == "Active" ? "In use" : "Pending"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                        <div className="panel-table-list-item">
                            <div className="panel-table-listing-item__inner">
                                <Link to={'/settings/payment'}>
                                    <i className="bi bi-box-arrow-up-right" /> Payment section{" "}
                                </Link>
                            </div>
                        </div>
                    </CardPanel> */}
                    {/* <CardPanel
                        headerTitle={'Payment methods'}
                        headerSubTitle={'Brief list of payment methods use in'}
                        panelHeaderTitle={'No records available'}>
                        <div className="empty-stack__wrapper">
                            <img src="/src/assets/images/empty-stack-holder.svg" alt="" />
                            <h4>No Data Available</h4>
                        </div>
                    </CardPanel> */}
                    {/* / empty table stack*/}
                </div>
            </div>
            <Modal
                display={displayMsisdnModal}
                onClose={() => setDisplayMsisdnModal(false)}
                onConfirm={() => setDisplayMsisdnModal(false)}
            >
                <div className="card panel content-holder-panels">
                    <div className="panel-header">
                        <div className="panel-header-content__wrapper">
                            <h4 className="panel-header-title">Your Numbers</h4>
                            <p className="panel-header-subtitle">
                                List of numbers reserved for charging; choose one.
                            </p>
                        </div>
                    </div>
                    {/* panel table */}
                    <div className="panel-table-listing__wrapper">
                        <div className="panel-table-listing">
                            <div className="panel-table-content-list">
                                {msisdnList && Array.isArray(msisdnList) && msisdnList.map((value: any, index: number) => {
                                    return (
                                        <div className="panel-table-list-item" key={index}>
                                            <div className="panel-table-listing-item__inner">
                                                <div className="feature-details__wrapper">
                                                    <div className="card app-media-holder orange-shade sm-center-icon-card">
                                                        <span className="icon__wrapper">
                                                            <i className="bi bi-sim-fill" />
                                                        </span>
                                                    </div>
                                                    <div className="feature-details-title__wrapper no-shade">
                                                        <span className="title">{value.msisdn}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-table-listing-item__inner">
                                                <div className="panel-table-right-align-item__wrapper">
                                                    <div className="panel-table-right-align-item">
                                                        <div className="form-group__wrapper"></div>
                                                    </div>
                                                    <label className="switch">
                                                        <input
                                                            type="radio"
                                                            name='number-change'
                                                            onChange={onChangeNumber}
                                                            value={value.msisdn}
                                                            checked={activeMsisdnObj && activeMsisdnObj.msisdn == value.msisdn}
                                                        />
                                                        <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                display={displayCardModal}
                onClose={() => setDisplayCardModal(false)}
                onConfirm={() => setDisplayCardModal(false)}
            >
                <div className="card panel content-holder-panels">
                    <div className="panel-header">
                        <div className="panel-header-content__wrapper">
                            <h4 className="panel-header-title">Your Genie cards</h4>
                            <p className="panel-header-subtitle">
                                List of your cards, reserved for payments, other, other, etc.
                            </p>
                        </div>
                    </div>
                    {/* panel table */}
                    <div className="panel-table-listing__wrapper">
                        <div className="panel-table-listing">
                            <div className="panel-table-content-list">
                                {cardList && Array.isArray(cardList) && cardList.map((value: any, index: number) => {
                                    return (
                                        <div className="panel-table-list-item" key={index}>
                                            <div className="panel-table-listing-item__inner">
                                                <div className="feature-details__wrapper">
                                                    <div className="card app-media-holder orange-shade sm-center-icon-card">
                                                        <span className="icon__wrapper">
                                                            <i className="bi bi-sim-fill" />
                                                        </span>
                                                    </div>
                                                    <div className="feature-details-title__wrapper no-shade">
                                                        <span className="title">{value.maskCardNo}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-table-listing-item__inner">
                                                <div className="panel-table-right-align-item__wrapper">
                                                    <div className="panel-table-right-align-item">
                                                        <div className="form-group__wrapper"></div>
                                                    </div>
                                                    <label className="switch">
                                                        <input
                                                            type="radio"
                                                            name='card-change'
                                                            onChange={onChangeCard}
                                                            value={JSON.stringify(value)}
                                                            checked={activeCardObj?.invoiceNo == value?.invoiceNo}
                                                        />
                                                        <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
}

export default BillingAndPlans;